import angular from 'angular';

import docusignContractModal from './docusignContractModal.component';
import dynamarkProhibitModal from './dynamarkProhibitModal.component';

export default angular.module('fp:customerportal:common:modals', [

])
    .component('fpDocusignContractModal', docusignContractModal)
    .component('fpDynamarkProhibitModal', dynamarkProhibitModal);